import React from 'react'
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Card = styled.div`
    min-width: 300px;
    min-height: 220px;
    background: rgb(9,104,121);
    background: linear-gradient(126deg, rgba(9,104,121,1) 39%, rgba(6,97,166,1) 60%, rgba(0,83,251,0.49763655462184875) 100%);
    margin: 10px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
    border-radius: 10px;
    box-shadow: 25px 25px 50px rgba(9, 148, 255, 0.25), 
                -10px -10px 30px rgba(9, 148, 255, 0.1), 
                inset -5px -5px 15px rgba(9, 148, 255, 0.5);
    
    &:hover {
        background: rgb(9,25,121);
        background: linear-gradient(126deg, rgba(9,25,121,0.49763655462184875) 35%, rgba(0,212,255,0.49763655462184875) 100%);    
        }
    
`

const CardLink = styled(Link)`
    text-decoration: none;
    color: inherit;
    flex: 1;
`

const CardContent = styled.h1`
    padding: 10px;
    margin: 0;
    text-align: center;
`

const ContentDesc = styled.p`

    padding: 10px;
    margin: 0;
    text-align: center;
`

const PayeeCard = ({payee : {payeeId, payeeName, payeeDesc, payeeOwner, payeeBank, payeeAcct, createdDate}}) => {
    return (
        <CardLink to={`/payees/${payeeId}`}>
            <Card>
                <CardContent>
                    {payeeName}
                </CardContent>
                <ContentDesc>
                    {payeeDesc}
                </ContentDesc>
                <CardContent>
                    {payeeBank}
                </CardContent>
                <CardContent>
                    {payeeAcct}
                </CardContent>
                <CardContent>
                    {payeeOwner ? `Owner: ${payeeOwner}` : ''}
                </CardContent>
            </Card>
        </CardLink>
        
    )
}

export default PayeeCard
